<template>
  <div class="invitedUser">
    <div class="step">
      <div class="stepItem">
        <span class="name">STEP.1</span>
        <span class="right">填写信息，确认提交</span>
      </div>
      <div class="icon_box">
        <van-icon name="arrow-down" />
      </div>
      <div class="stepItem">
        <span class="name">STEP.2</span>
        <span class="right">体验价格（0）元，可到场后支付</span>
      </div>
      <div class="icon_box">
        <van-icon name="arrow-down" />
      </div>
      <div class="stepItem">
        <span class="name">STEP.3</span>
        <span class="right">确认预约的老师会在第一时间联系您并确定时间后直接拨打电话</span>
      </div>
    </div>

    <van-form>
      <div class="userPhone">
        <div class="title">预约后我们将通过电话联系您</div>
        <div class="number">
          <van-field
            v-model="phone"
            required
            type="tel"
            maxlength="11"
            name="手机号"
            label=""
            placeholder="预留电话"
          >
            <template #button>
              <van-button :disabled="codeLoading || !!timer" :loading="codeLoading" loading-text="发送验证码" size="small" type="primary" @click="sendCode">{{sendText}}</van-button>
            </template>
          </van-field>
        </div>
      </div>
      <van-field
        v-model="code"
        type="digit"
        required
        name="验证码"
        label="验证码"
        label-width="3em"
        placeholder="验证码"
      />
      <van-field
        v-model="name"
        required
        :name="isMoreShow ? '学员姓名(中文)' : '学员姓名'"
        :label="isMoreShow ? '学员姓名(中文)' : '学员姓名'"
        :label-width="isMoreShow ? '7em' : '4em'"
        :placeholder="isMoreShow ? '学员姓名(中文)' : '学员姓名'"
      />
      <van-field
        v-if="isMoreShow"
        v-model="nameEn"
        required
        name="学员姓名(英文)"
        label="学员姓名(英文)"
        label-width="7em"
        placeholder="学员姓名(英文)"
      />
      <van-field
        v-model="age"
        required
        type="digit"
        name="学生年龄"
        label="学生年龄"
        label-width="4em"
        placeholder="学生年龄"
      />
      <van-field
        name="sex"
        label="性别"
        label-width="2em"
        required
      >
        <template #input>
          <van-radio-group v-model="sex" direction="horizontal">
            <van-radio name="2" checked-color="#00CBCC">保密</van-radio>
            <van-radio name="1" checked-color="#00CBCC">男</van-radio>
            <van-radio name="0" checked-color="#00CBCC">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      
      <template v-if="isMoreShow">
        <van-field
          class="flexColumn"
          name="isVocalMusic"
          label="是否接受过声乐训练？"
          label-width="10em"
          required
        >
          <template #input>
            <van-radio-group v-model="isVocalMusic" direction="horizontal">
              <van-radio :name="true" checked-color="#00CBCC">是</van-radio>
              <van-radio :name="false" checked-color="#00CBCC">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          class="flexColumn"
          name="isDance"
          label="是否接受过舞蹈训练？"
          label-width="10em"
          required
        >
          <template #input>
            <van-radio-group v-model="isDance" direction="horizontal">
              <van-radio :name="true" checked-color="#00CBCC">是</van-radio>
              <van-radio :name="false" checked-color="#00CBCC">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          class="flexColumn"
          name="isPerform"
          label="是否接受过表演训练？"
          label-width="10em"
          required
        >
          <template #input>
            <van-radio-group v-model="isPerform" direction="horizontal">
              <van-radio :name="true" checked-color="#00CBCC">是</van-radio>
              <van-radio :name="false" checked-color="#00CBCC">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          class="flexColumn"
          v-model="otherInstruments"
          name="是否学习过其他乐器？"
          label="是否学习过其他乐器？"
          label-width="14em"
          placeholder="请填写"
        />
        <van-field
          class="flexColumn"
          v-model="englishCertificate"
          name="当前英文等级水平及获奖证书"
          label="当前英文等级水平及获奖证书"
          label-width="14em"
          placeholder="请填写"
        />
      </template>

      <div class="safe">
        <span>无强行推销</span>
        <span>不泄露用户手机号码</span>
      </div>

      <div>
        <van-button round block type="info" @click="onSubmit">提交</van-button>
      </div>
    </van-form>

    <van-overlay :show="submitLoading">
      <div style="height: 100%;display: flex;align-items: center;justify-content: center;">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Form, Field, Button, RadioGroup, Radio, Toast, Overlay, Loading, Icon } from 'vant'
import { validMobile } from '@/utils/validate.js'
import { addInvitedUser, GetIsShowMore } from '@/api/activity.js'
import { ApiSendCode } from '@/api/login.js'

export default {
  name: 'invitedUser',
  components: {
    vanForm: Form,
    vanField: Field,
    vanButton: Button,
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
    vanOverlay: Overlay,
    vanLoading: Loading,
    vanIcon: Icon,
  },
  data() {
    return {
      uid: '',
      name: '',
      nameEn: '',
      phone: '',
      code: '',
      age: '',
      sex: '',
      isVocalMusic: null,
      isDance: null,
      isPerform: null,
      otherInstruments: '',
      englishCertificate: '',
      rules: {
        phone: [
          { required: true, message: '请填写手机号' },
          { validator: (value) => {
            if (value) {
              return validMobile(value)
            } else {
              return true
            }
          }, message: '请输入正确的手机号'}
        ],
        age: [
          { required: true, message: '请填写年龄' },
          { validator: (value) => {
            if (value) {
              if (Number(value) < 0 || Number(value) > 100)
              return false
            } else {
              return true
            }
          }, message: '请输入正确的年龄'}
        ],
      },
      isMoreShow: false,
      timer: null,
      count: 60,
      sendText: '发送验证码',
      submitLoading: false,
      codeLoading: false,
    }
  },
  mounted() {
    this.uid = this.$route.query.uid
    this.requestGetIsShowMore()
  },
  methods: {
    requestGetIsShowMore() {
      GetIsShowMore({ uid: this.uid }).then(res => {
        if (res.code === 200) {
          this.isMoreShow = res.data
        }
      })
    },
    sendCode(){
      let telReg = validMobile(this.phone)
      if (!telReg) {
        Toast('请输入正确的手机格式')
        return
      }
      if (this.timer) { return }
      this.codeLoading = true
      ApiSendCode({phone: this.phone, smsType: 10}).then(res => {
        this.codeLoading = false
        if(res.code == 200){
          Toast(res.msg)
          this.startTimer()
        } else {
          Toast(res.msg)
          this.stopTimer()
        }
      }).catch(() => {
        this.codeLoading = false
      })
    },
    startTimer() {
      this.stopTimer()
      this.count--
      this.sendText = this.count + "S"
      this.timer = setInterval(()=>{
        if (this.count >= 1) {
          this.count--
          this.sendText = this.count + "S"
        } else {
          this.stopTimer()
        }
      }, 1000)
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
        this.count = 60
        this.sendText = "发送验证码"
      }
    },
    onSubmit() {
      if (this.submitLoading) return

      let telReg = validMobile(this.phone)
      if (!telReg) {
        Toast('请输入正确的手机格式')
        return
      }

      if (!this.code) {
        Toast('请输入验证码')
        return
      }

      if (!this.name) {
        if (this.isMoreShow) {
          Toast('请输入学生姓名(中文)')
        } else {
          Toast('请输入学生姓名')
        }
        return
      }

      if (!this.age) {
        Toast('请输入学生年龄')
        return
      }

      if (!this.sex) {
        Toast('请输入性别')
        return
      }
      
      if (this.isMoreShow) {
        if (!this.nameEn) {
          Toast('请输入学生姓名(英文)')
          return
        }
        if (this.isVocalMusic === null) {
          Toast('请选择是否接受过声乐训练')
          return
        }
        if (this.isDance === null) {
          Toast('请选择是否接受过舞蹈训练')
          return
        }
        if (this.isPerform === null) {
          Toast('请选择是否接受过表演训练')
          return
        }
      }

      let params = {
        uid: this.uid,
        name: this.name,
        phone: this.phone,
        code: this.code,
        age: this.age,
        sex: this.sex,
      }

      if (this.isMoreShow) {
        params.nameEn = this.nameEn
        params.isVocalMusic = this.isVocalMusic
        params.isDance = this.isDance
        params.isPerform = this.isPerform
        params.otherInstruments = this.otherInstruments
        params.englishCertificate = this.englishCertificate
      }

      this.submitLoading = true
      addInvitedUser(params).then(res => {
        this.submitLoading = false
        Toast(res.msg)
        if (res.code === 200) {
          this.$router.push({ path: '/invitedUserSuccess' })
        }
      }).catch(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style lang="scss">
@import '../assets/css/flexable.scss';

.invitedUser {
  width: 100%;
  padding: 0 38px;
  text-align: left;
  box-sizing: border-box;
  overflow: auto;

  .step {
    padding: 20px 0;
    color: #D2D2D2;
    .stepItem {
      position: relative;
      display: flex;
      padding: 4px 7px;
      border-radius: 4px;
      background-color: #F5F5F9;
      .name {
        font-size: 13px;
        font-weight: bold;
        color: #00CBCC;
        line-height: 20px;
      }
      .right {
        margin-left: 5px;
        width: 80%;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .icon_box {
      padding: 6px 0;
      text-align: center;
      color: #000;
    }
  }

  .userPhone {
    .title {
      margin-bottom: 20px;
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      color: #1F1F1F;
    }
    .number {
      position: relative;
      border-radius: 4px;
      background: #F5F5F9;
      .van-cell {
        background-color: transparent;
      }
    }
  }

  .safe {
    margin-top: 16px;
    padding-bottom: 20px;
    span {
      padding-left: 3.5vw;
      background: url(https://oss.dayulong.cn/mini/safe.png) no-repeat left center;
      background-size: 2.5vw 3vw;
      margin-right: 4.4vw;
      color: #1F1F1F;
    }
  }

  .flexColumn {
    display: flex;
    flex-direction: column;
    .van-cell__title {
      margin-bottom: 10px;
    }
  }
}
</style>